/**
 * ASCII Art Library for Terminal Portfolio
 * Contains various ASCII art elements for decorative purposes
 */

// Tech-themed icons
export const icons = {
  computer: `
   ___________
  |._________.|
  |._________.|
  |           |
  |   ASCII   |
  |___________|
  `,

  terminal: `
  ┌─────────┐
  │ >_ ___  │
  │  |___   │
  └─────────┘
  `,

  code: `
  { /* */ }
    </>
  `,

  rocket: `
      /\\
     /  \\
    |    |
    |NASA|
   /|    |\\
  / |____| \\
    |    |
   /|    |\\
  / |____| \\
   /_/  \\_\\
  `,

  brain: `
    ____
   /    \\
  | O  O |
  |  <>  |
   \\____/
  `,

  lightbulb: `
    .--.
   /    \\
  |      |
  |      |
   \\____/
     ||
     ||
    /__\\
  `,

  star: `
    *
   ***
  *****
   ***
    *
  `,

  check: `
      __
     /  \\
    /    \\
   /  /\\  \\
      /  /
     /  /
  `,

  warning: `
     /\\
    /  \\
   / !! \\
  /______\\
  `,
}

// Decorative dividers
export const dividers = {
  wave: '~·~·~·~·~·~·~·~·~·~·~·~·~·~·~·~·~·~·~·~·~·~·~·~·~·~·~·~',

  dash: '━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━',

  dot: '· · · · · · · · · · · · · · · · · · · · · · · · · ·',

  arrow: '▶▶▶▶▶▶▶▶▶▶▶▶▶▶▶▶▶▶▶▶▶▶▶▶▶▶▶▶▶▶▶▶▶▶▶▶▶▶▶▶▶▶▶▶▶▶▶▶',

  circuit: '─┼─┼─┼─┼─┼─┼─┼─┼─┼─┼─┼─┼─┼─┼─┼─┼─┼─┼─┼─┼─┼─┼─┼─',

  double: '═══════════════════════════════════════════════════',

  stars: '✦ ✦ ✦ ✦ ✦ ✦ ✦ ✦ ✦ ✦ ✦ ✦ ✦ ✦ ✦ ✦ ✦ ✦ ✦ ✦',

  blocks: '▀▀▀▀▀▀▀▀▀▀▀▀▀▀▀▀▀▀▀▀▀▀▀▀▀▀▀▀▀▀▀▀▀▀▀▀▀▀▀▀▀▀▀▀▀▀▀▀',

  gradient: '░▒▓█▓▒░▒▓█▓▒░▒▓█▓▒░▒▓█▓▒░▒▓█▓▒░▒▓█▓▒░▒▓█▓▒░▒▓█▓▒░',
}

// Section headers
export const headers = {
  about: `
   ╔═══════════════════════════════════════════════════════╗
   ║              🧑‍💻  ABOUT  ANDERSON  🧑‍💻                ║
   ╚═══════════════════════════════════════════════════════╝
  `,

  projects: `
   ┏━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━┓
   ┃            🚀  FEATURED  PROJECTS  🚀              ┃
   ┗━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━┛
  `,

  skills: `
   ╭───────────────────────────────────────────────────────╮
   │             ⚡  TECHNICAL  SKILLS  ⚡               │
   ╰───────────────────────────────────────────────────────╯
  `,

  experience: `
   ┌─────────────────────────────────────────────────────┐
   │           💼  WORK  EXPERIENCE  💼                 │
   └─────────────────────────────────────────────────────┘
  `,

  contact: `
   ╔═════════════════════════════════════════════════════╗
   ║            📧  GET  IN  TOUCH  📧                  ║
   ╚═════════════════════════════════════════════════════╝
  `,

  blog: `
   ╭─────────────────────────────────────────────────────╮
   │            📝  THOUGHT  LOG  📝                    │
   ╰─────────────────────────────────────────────────────╯
  `,
}

// Status indicators
export const status = {
  success: `
   ╔═══╗
   ║ ✓ ║  SUCCESS
   ╚═══╝
  `,

  error: `
   ╔═══╗
   ║ ✗ ║  ERROR
   ╚═══╝
  `,

  info: `
   ╔═══╗
   ║ ℹ ║  INFO
   ╚═══╝
  `,

  warning: `
   ╔═══╗
   ║ ⚠ ║  WARNING
   ╚═══╝
  `,

  loading: `
   [████▓▓▓▓░░░░]
   PROCESSING...
  `,
}

// Small decorative elements
export const decorations = {
  bullet: '▸',
  arrow: '→',
  corner: '└─',
  branch: '├─',
  pipe: '│',
  dotBullet: '•',
  starBullet: '✦',
  triangleBullet: '▶',
  circleBullet: '◉',
  squareBullet: '▪',
}

// Welcome/boot ASCII art
export const welcome = {
  logo: `
   ▄▀█ █▄░█ █▀▄ █▀▀ █▀█ █▀ █▀█ █▄░█
   █▀█ █░▀█ █▄▀ ██▄ █▀▄ ▄█ █▄█ █░▀█

   █▀█ █▀▀ █ █▄░█ █▄▀ █▀█ █▀█ █▀▄ ▀█▀
   █▀▄ ██▄ █ █░▀█ █░█ █▄█ █▀▄ █▄▀ ░█░
  `,

  banner: `
   ╔════════════════════════════════════════════════════╗
   ║                                                    ║
   ║         PORTFOLIO  TERMINAL  v1.0                 ║
   ║         Accessible AI Engineering                  ║
   ║                                                    ║
   ╚════════════════════════════════════════════════════╝
  `,

  prompt: `
   ┌─[ anderson@portfolio ]─[ ~ ]
   └─▶
  `,
}

// Combine all exports
export const asciiArt = {
  icons,
  dividers,
  headers,
  status,
  decorations,
  welcome,
}

export default asciiArt
